// @flow

import React from 'react';

import CORE_PRODUCT_TYPES from 'client/constants/productTypes';
import ROUTES from 'client/constants/routes';

import type { LocaleType } from 'types/locale.flow';
import type { IfpAppType } from 'web-core/types/ifp-app';

const getCartPlanDetails = ({ app_json, type }) => {
  const planName = type === CORE_PRODUCT_TYPES.HEALTH ? app_json.plan.planName : app_json.plan.name;
  const monthlyPremium =
    type === CORE_PRODUCT_TYPES.HEALTH
      ? app_json.plan.mods.premiumMonth
      : app_json.plan.premiumMonth;
  const carrierName = app_json.plan.carrier;
  let changeHref;

  switch (type) {
    case CORE_PRODUCT_TYPES.HEALTH:
      changeHref = ROUTES.HEALTH_PROFILE_RECOMMENDATIONS_ROUTE;
      break;
    case CORE_PRODUCT_TYPES.DENTAL:
      changeHref = ROUTES.DENTAL_PLANS_ROUTE;
      break;
    case CORE_PRODUCT_TYPES.VISION:
      changeHref = ROUTES.VISION_PLANS_ROUTE;
      break;
    default:
      break;
  }

  return { carrierName, changeHref, monthlyPremium, planName };
};

type Props = {
  app: IfpAppType,
  children: Function,
  fetchCart: Function,
  fetchActiveApps: Function,
  locale: LocaleType,
  resetApp: Function,
};

const CartPlanDetail = ({ app, children, fetchActiveApps, fetchCart, locale, resetApp }: Props) => {
  const { app_id, app_json, members, type, product_application_id } = app;
  const { carrierName, changeHref, monthlyPremium, planName } = getCartPlanDetails({
    app_json,
    type,
  });
  const cartPlanDetailProps = {
    app_id,
    carrierName,
    changeHref,
    fetchActiveApps,
    fetchCart,
    locale,
    members,
    monthlyPremium,
    planName,
    resetApp,
    type,
    applicationId: product_application_id,
  };
  return <React.Fragment>{children(cartPlanDetailProps)}</React.Fragment>;
};

export default CartPlanDetail;
